import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h10.5","key":"svg-1"}],["path",{"d":"M9 18h5","key":"svg-2"}],["path",{"d":"M19 22v.01","key":"svg-3"}],["path",{"d":"M19 19c.448 -.001 .883 -.153 1.235 -.431c.352 -.278 .6 -.666 .706 -1.101c.105 -.436 .061 -.894 -.125 -1.302c-.186 -.408 -.504 -.742 -.902 -.948c-.398 -.204 -.853 -.267 -1.291 -.179c-.438 .088 -.834 .321 -1.123 .662","key":"svg-4"}]]

const IconFilter2Question = createReactComponent('outline', 'filter-2-question', 'Filter2Question', __iconNode);

export default IconFilter2Question;